<template lang="html">
  <div class="vh-100 overflow-y-scroll">
    <div class="flex flex-nowrap pa2">
      <pl-button @click.native="$router.go(-1)" class="pl-primary-reverse b">
        < GO BACK</pl-button
      >
    </div>

    <div class="row" style="margin-left: 10px">
      <div class="premade-list-container col-xs-12 col-sm-3 col-md-2 h-100">
        <h2>Filter RoundTables</h2>
        <div class="premade-search-bar">
          <div class="search-bar">
            <pl-input
              v-model="title_query"
              placeholder="Search Titles"
              @keyup.enter="loadPremades()"
            />
          </div>
          <div class="search-bar">
            <pl-input
              v-model="author_query"
              placeholder="Search by Author"
              @keyup.enter="loadPremades()"
            />
          </div>
          <div class="search-bar">
            <multiselect
              v-model="selected_categories"
              :options="categories"
              :multiple="true"
              :close-on-select="false"
              :clear-on-select="false"
              :preserve-search="true"
              placeholder="Collections"
              label="name"
              track-by="id"
              :preselect-first="true"
              @input="loadPremades()"
            >
              <template
                slot="selection"
                slot-scope="{ values, search, isOpen }"
              >
                <span
                  class="multiselect__single"
                  v-if="selected_categories.length &amp;&amp; !isOpen"
                >
                  {{ selected_categories.length }} options selected
                </span>
              </template>
            </multiselect>
          </div>
          <div class="search-bar">
            <multiselect
              v-model="selected_subjects"
              :options="subjects"
              :multiple="true"
              :close-on-select="false"
              :clear-on-select="false"
              :preserve-search="true"
              placeholder="Subjects"
              label="name"
              track-by="id"
              :preselect-first="true"
              @input="loadPremades()"
            >
              <template
                slot="selection"
                slot-scope="{ values, search, isOpen }"
              >
                <span
                  class="multiselect__single"
                  v-if="selected_subjects.length &amp;&amp; !isOpen"
                  >{{ selected_subjects.length }} options selected</span
                >
              </template>
            </multiselect>
          </div>
          <div class="search-bar">
            <pl-select
              :options="premade_types"
              :selected="selected_premade_type"
              :arrow="true"
              style="padding: 0px; max-width: 300px"
              class="dialog-type-select capitalize"
              @change="selectPremadeType($event)"
            >
            </pl-select>
          </div>
          <h4 class="mb1">Certification:</h4>
          <div>
            <div class="flex mb1">
              <pl-checkbox
                v-model="parlay_certified"
                @change="loadPremades()"
              />
              <span>Parlay Certified</span>
            </div>
            <div class="flex">
              <pl-checkbox
                v-model="parlay_not_certified"
                @change="loadPremades()"
              />
              <span>Not Certified</span>
            </div>
          </div>
          <h4 class="mb1">Privacy:</h4>
          <div>
            <div class="flex mb1">
              <pl-checkbox v-model="privacy_public" @change="loadPremades()" />
              <span>Public</span>
            </div>
            <div class="flex mb1">
              <pl-checkbox v-model="privacy_private" @change="loadPremades()" />
              <span>Unlisted</span>
            </div>
            <div class="flex">
              <pl-checkbox v-model="privacy_draft" @change="loadPremades()" />
              <span>Draft</span>
            </div>
          </div>
          <h4 class="mb1">Replications:</h4>
          <div>
            <div class="flex mb1">
              <pl-checkbox v-model="replications_0" @change="loadPremades()" />
              <span>0</span>
            </div>
            <div class="flex mb1">
              <pl-checkbox
                v-model="replications_1_10"
                @change="loadPremades()"
              />
              <span>1-10</span>
            </div>
            <div class="flex mb1">
              <pl-checkbox
                v-model="replications_10_100"
                @change="loadPremades()"
              />
              <span>10-100</span>
            </div>
            <div class="flex">
              <pl-checkbox
                v-model="replications_more100"
                @change="loadPremades()"
              />
              <span>100+</span>
            </div>
          </div>
        </div>
      </div>
      <div v-if="loading" class="col-xs-12 col-sm-9 col-md-10 h-100">
        <pl-spinner class="x2" style="margin: auto" />
      </div>
      <div v-else class="col-xs-12 col-sm-9 col-md-10 h-100">
        <div v-if="premades && premades.length" class="premade-list-container">
          <div class="row col-xs middle-xs between-xs">
            <div>
              <span>Found {{ total_premades }} Roundtables</span>
            </div>
            <div class="comment-filter">
              <pl-menu :menuSize="2" direction="right">
                <pl-button
                  slot="menu_trigger"
                  menu-trigger
                  style="text-transform: capitalize"
                >
                  {{ sortByDate }}
                  <i class="fa fa-filter fa-sm" />
                </pl-button>
                <ul menu-content>
                  <li
                    @click="
                      sortByDate = 'oldest';
                      loadPremades();
                    "
                    class="filter-list-item"
                  >
                    Oldest
                  </li>
                  <li
                    @click="
                      sortByDate = 'newest';
                      loadPremades();
                    "
                    class="filter-list-item"
                  >
                    Newest
                  </li>
                </ul>
              </pl-menu>
              <pl-menu :menuSize="2" direction="right">
                <pl-button
                  slot="menu_trigger"
                  menu-trigger
                  style="text-transform: capitalize"
                >
                  {{ sortByCreated }}
                  <i class="fa fa-filter fa-sm" />
                </pl-button>
                <ul menu-content>
                  <li
                    @click="
                      sortByCreated = 'created';
                      loadPremades();
                    "
                    class="filter-list-item"
                  >
                    Created
                  </li>
                  <li
                    @click="
                      sortByCreated = 'edited';
                      loadPremades();
                    "
                    class="filter-list-item"
                  >
                    Edited
                  </li>
                </ul>
              </pl-menu>
            </div>
          </div>
          <div class="row">
            <search-edit-premade-card
              class="fl"
              v-for="premade in premades"
              :premade="premade"
              :key="premade.id"
            />
          </div>
          <div class="row w-100 center-xs mt4 mb4">
            <pl-button
              v-if="!load_more_premades"
              class="pl-primary-secondary pl-small"
              style="margin: 0; font-style: italic; font-size: 16px"
              @click.native="
                show_more_premades ? loadMorePremades(page_number) : ''
              "
            >
              {{
                show_more_premades ? 'Load More Premades' : 'No More Premades'
              }}
            </pl-button>
            <div v-if="load_more_premades">
              <pl-spinner class="x5" />
            </div>
          </div>
        </div>
        <div
          v-else
          class="col-xs-12 col-md-10"
          style="text-align: center; font-size: 25px"
        >
          No results for this filter(s)
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import premadeServices from 'services/premades/premadeServices';
  import searchEditPremadeCard from 'features/onlineRoundtables/components/searchEditPremadeCard/searchEditPremadeCard.vue';
  import Multiselect from 'vue-multiselect';

  export default {
    components: {
      searchEditPremadeCard,
      Multiselect,
    },
    data() {
      return {
        premades: [],
        subjects: [],
        premade_types: ['all', 'verbal', 'written'],
        categories: [],
        grade_levels: [],
        selected_subjects: [],
        selected_premade_type: 'all',
        selected_categories: [],
        title_query: '',
        author_query: '',
        parlay_certified: false,
        parlay_not_certified: false,
        privacy_public: false,
        privacy_private: false,
        privacy_draft: false,
        replications_0: false,
        replications_1_10: false,
        replications_10_100: false,
        replications_more100: false,
        sortByDate: 'newest',
        sortByCreated: 'created',
        filters: {},
        page_size: 18,
        page_number: 1,
        load_more_premades: false,
        show_more_premades: true,
        loading: false,
        total_premades: 0,
      };
    },
    methods: {
      loadPremades(append_results) {
        if (!append_results) {
          this.page_number = 1;
          this.loading = true;
          this.show_more_premades = true;
        }

        this.filters = {
          title: this.title_query,
          author: this.author_query,
          collections: this.selected_categories.map((category) => category.id),
          subjects: this.selected_subjects.map((subject) => subject.id),
          certification: this.getCertification(),
          privacy: this.getAccessibility(),
          replications: this.getReplications(),
          page_number: this.page_number,
          page_size: this.page_size,
          sortBy: [this.sortByDate, this.sortByCreated],
        };
        if (this.selected_premade_type !== 'all') {
          this.filters.type = this.selected_premade_type;
        }
        return premadeServices
          .getPremadesByPage(this.filters)
          .then(({ data }) => {
            this.loading = false;
            this.page_number = data.page_number;
            this.total_premades = data.total_premades;
            if (data.premades && data.premades.length > 0) {
              if (append_results) {
                this.premades.push(...data.premades);
              } else {
                this.premades = data.premades;
              }
            } else {
              if (this.page_number === 1) {
                this.premades = [];
              }

              this.show_more_premades = false;
            }
            this.load_more_premades = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading = false;
            this.show_more_premades = false;
            this.load_more_premades = false;
          });
      },
      getAccessibility() {
        const privacy = ['Public', 'Unlisted', 'Draft'];
        const values = [
          this.privacy_public,
          this.privacy_private,
          this.privacy_draft,
        ];
        let result = [];
        for (let index = 0; index < privacy.length; index += 1) {
          if (values[index]) {
            result.push(privacy[index]);
          }
        }
        return result;
      },
      getCertification() {
        if (this.parlay_certified === this.parlay_not_certified) {
          return null;
        }
        if (this.parlay_not_certified) {
          return false;
        }
        return true;
      },
      getReplications() {
        let replications = [
          [0, 1],
          [1, 10],
          [10, 100],
          [100, null],
        ];
        let values = [
          this.replications_0,
          this.replications_1_10,
          this.replications_10_100,
          this.replications_more100,
        ];
        let result = [];
        for (let index = 0; index < replications.length; index += 1) {
          if (values[index]) {
            result.push(replications[index]);
          }
        }
        return result;
      },
      loadMorePremades() {
        this.load_more_premades = true;
        this.page_number += 1;

        this.loadPremades(true);
      },
      selectPremadeType(premade_type) {
        this.selected_premade_type = premade_type;
        this.loadPremades();
      },
    },
    mounted() {
      this.$store
        .dispatch('getAllSubjects')
        .then((results) => (this.subjects = results));

      this.$store
        .dispatch('getAllUniverseCategories')
        .then((results) => (this.categories = results));

      this.loading = true;
      this.loadPremades(false);
    },
  };
</script>

<style scoped lang="stylus">
  @import '~app/global-stylus.styl';

  .premade-search-bar {
    overflow: hidden;
  }

  .search-bar {
    padding-top: 15px;
    padding-right: 15px;
  }

  .dropdown {
    position: relative;
    width: 7em;
    outline: none;
    border-radius: 5px;

    &:focus {
      border-color: pl-primary;
    }
  }

  .comment-filter {
    margin-right: 20px;
    text-align: right;
  }

  .dialog-type-select {
    height: 40px;
    border: 2px solid #e1e8ee;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
  }
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
  .multiselect__tag {
    background: #72ccd7;
  }
  .multiselect__option--highlight {
    background: #72ccd7;
  }
  .multiselect__option--highlight:after {
    background: #72ccd7;
  }
  .multiselect__spinner:after {
    border-color: #72ccd7 transparent transparent;
  }
  .multiselect__tag-icon:after {
    color: white;
  }
  .multiselect__tag-icon:hover {
    background: #63b1bb;
  }
  .multiselect__tags {
    border: 2px solid #e1e8ee;
  }
  .multiselect__placeholder {
    color: black;
  }
</style>
<style lang="scss" scoped>
  .input-container {
    padding: 0 !important;
  }
  .label-default {
    padding-left: 0px !important;
  }
  input.default {
    height: 40px !important;
  }
</style>



// WEBPACK FOOTER //
// searchEditPremades.vue?10b41665